export default "https://cdn-static.gokick.com/assets/8bc125c24491fd75c87852671f08945500f37a20/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";